import { render, staticRenderFns } from "./IonlineApnRealm.vue?vue&type=template&id=237aba10&scoped=true&"
import script from "./IonlineApnRealm.vue?vue&type=script&lang=js&"
export * from "./IonlineApnRealm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237aba10",
  null
  
)

export default component.exports